import React from 'react'
import SvgColor from '../../../components/svg-color';

const icon = (name) => <SvgColor src={`/assets/icons/navbar/${name}.svg`} sx={{ width: 1, height: 1 }} />;

const adminMapList = (pathName) => {
    return [
        {
            id: 1,
            title: 'Users',
            path: `/${pathName}/users`,
            icon: icon('ic_user'),
        },
        {
            id: 2,
            title: 'All Transaction',
            path: `/${pathName}/all-transactions`,
            icon: icon('ic_transactions'),
        },
        {
            id: 3,
            title: 'Payment Requests',
            path: `/${pathName}/payment-requests`,
            icon: icon('ic_service'),
        },
        {
            id: 4,
            title: 'Disputes',
            path: `/${pathName}/dispute-resolution`,
            icon: icon('ic_dispute'),
        },
        {
            id: 5,
            title: 'All Referrals',
            path: `/${pathName}/all-referrals`,
            icon: icon('ic_service'),
        },
        {
            id: 6,
            title: 'All Tasks',
            path: `/${pathName}/all-tasks`,
            icon: icon('ic_service'),
        },
        {
            id: 7,
            title: 'All UTMs',
            path: `/${pathName}/all-utm`,
            icon: icon('ic_service'),
        },
        {
            id: 8,
            title: 'Cancellation Reason',
            path: `/${pathName}/cancellationReason`,
            icon: icon('ic_service'),
        },
        {
            id: 9,
            title: 'Blogs',
            path: `/${pathName}/blogs`,
            icon: icon('ic_service'),
        },
        {
            id: 10,
            title: 'Services',
            path: `/${pathName}/services`,
            icon: icon('ic_service'),
        },
        {
            id: 11,
            title: 'Skills',
            path: `/${pathName}/skills`,
            icon: icon('ic_service'),
        },
        {
            id: 12,
            title: 'Highest Degree',
            path: `/${pathName}/highest-degree`,
            icon: icon('ic_service'),
        },
        {
            id: 13,
            title: 'Software Required',
            path: `/${pathName}/software-required`,
            icon: icon('ic_service'),
        },
        {
            id: 14,
            title: 'Specialization',
            path: `/${pathName}/specialization`,
            icon: icon('ic_service'),
        },
        {
            id: 15,
            title: 'Subjects',
            path: `/${pathName}/subjects`,
            icon: icon('ic_service'),
        },
        {
            id: 16,
            title: 'Assignment Type',
            path: `/${pathName}/assignment-type`,
            icon: icon('ic_service'),
        },
        {
            id: 17,
            title: 'University',
            path: `/${pathName}/university`,
            icon: icon('ic_service'),
        },
        {
            id: 18,
            title: 'Country',
            path: `/${pathName}/countries`,
            icon: icon('ic_service'),
        },
        {
            id: 19,
            title: 'About Us',
            path: `/${pathName}/about-us`,
            icon: icon('ic_service'),
        },
        {
            id: 20,
            title: 'Privacy Policy',
            path: `/${pathName}/privacy-policy`,
            icon: icon('ic_service'),
        },
        {
            id: 21,
            title: 'Terms & Conditions',
            path: `/${pathName}/terms`,
            icon: icon('ic_service'),
        },
        {
            id: 22,
            title: 'Manage Admin Users',
            path: `/${pathName}/manage-admin-users`,
            icon: icon('ic_service'),
        },
        {
            id: 23,
            title: 'All Academic Test',
            path: `/${pathName}/academic-tests`,
            icon: icon('ic_service'),
        },
        {
            id: 24,
            title: 'Academic Test SET',
            path: `/${pathName}/academic-test-sets`,
            icon: icon('ic_service'),
        },
    ]
}

const adminUserConfig = (pathName, adminPaths, returnType) => {

    const getRouteMappedList = (allRouteList) => {
        let index = 0;
        let routeIndexes = [];

        do {
            const trimmedIndex = allRouteList[index]?.trim()

            if (!allRouteList?.length) {
                index = allRouteList?.length
                break;
            }

            if (trimmedIndex === "0") {
                routeIndexes = ["0"]
                index = allRouteList?.length
                break;
            }

            if (!routeIndexes?.includes(trimmedIndex?.toString()) && !isNaN(parseInt(trimmedIndex))) {
                routeIndexes?.push(trimmedIndex?.toString())
            }

            index++;

        } while (index < allRouteList?.length)

        return routeIndexes;
    }

    const pathList = (() => {
        let path = [] //use default

        const stringifiedPath = adminPaths?.toString()?.trim() ?? false

        if (stringifiedPath && stringifiedPath === "0") {
            path.push("0")
        } else if (stringifiedPath && stringifiedPath?.length > 0) {
            if (stringifiedPath?.includes(",")) {
                const allRouteList = stringifiedPath?.split(",")?.map(item => item?.trim()) ?? []
                path = getRouteMappedList(allRouteList)
            } else if (!isNaN(parseInt(stringifiedPath))) {
                path?.push(stringifiedPath)
            }
        } else {
            path = []
        }

        return path
    })();

    const defaultList = ['1', '5', '6', '7', '9', '10', '11', '12', '13',
        '14', '15', '16', '17', '18', '19', '20', '21']

    if (returnType === "url_structure") {
        if (pathList?.length) {
            return pathList
        } else {
            return defaultList
        }
    }

    const getList = (sharedList) => {
        return adminMapList(pathName)?.filter((item) => sharedList?.includes(item?.id?.toString()))
    }

    const visibleRoutes = !pathList?.length ? getList(defaultList) :
        pathList?.[0] === "0" ? adminMapList(pathName) : getList(pathList)

    return visibleRoutes
}

export default adminUserConfig